import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import React from 'react'
import AppHourCellSimple from '../AppointmentDaysSimple/AppDayDetailsSimple/AppHourCellSimple';
import App from 'App';
import { useContext } from 'react';
import './style.scss'
import { LanguageContext } from "App";
const HourAppointmentsTable = ({ SelectedApps }) => {
    console.log(SelectedApps);
    if (!SelectedApps) {
        return null;
    }
    const {translations} = useContext(LanguageContext)

    return (
        <MDBox class="hoursContainer">
            {
                SelectedApps.map((app, index) => {
                    return (


                        <div className='hourBox card'>
                                <div className='card-header'>
                                    <MDTypography className="appointment-hour-id">
                                        {translations.appointmentPatientsEnteriesAPPOINTMENTHOURID}: {app.id}
                                    </MDTypography>
                                </div>
                                <div className='card-body'>
                                    <div className='card-title'>
                                        <MDTypography className="Therapist-Name">
                                            {translations.appointmentPatientsEnteriesTherapistName} {app.therapistName}
                                        </MDTypography>
                                    </div>
                                    <div className="session-info" >
                                        
                                        <AppHourCellSimple  AppHour={app} />
                                    </div>
                                </div>
                        </div>


                    )
                })
            }
        </MDBox>
    )
}

export default HourAppointmentsTable